import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentEditFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-3 5-1.214 1.214-2-2L15 5l2 2Zm-3.786-.214 2 2L9 15H7v-2l6.214-6.214Z"
    />
  </svg>
);
export default IconCommentEditFilledSizeM;
